export const CONFIRM_WORD = "CLEAN START";

const LABELS = {
  leads: "Leads",
  delivery_attempts: "Lead deliveries",
  events: "Lead history entries",
  lead_revisions: "Lead edits",
  organizations: "Buyer, vendor and affiliate companies",
  users: "Logins",
  delivery_destinations: "Buyer delivery settings",
  custom_landing_pages: "Buyer and test landing pages",
  campaigns: "Campaigns",
  form_integrations: "Vendor form connections",
  postbacks: "Postbacks",
  rotator_links: "Rotator links",
  audit_log: "Audit log",
  landing_analytics_events: "Page visit stats",
  lp_daily_impressions: "Daily page views",
  global_funnel_daily: "Shared funnel visits",
  experiment_assignments: "A/B test visitors",
  ty_stats: "Thank-you results",
  ty_event_hits: "Thank-you events",
  call_taps: "Thank-you call taps",
  invoices: "Invoices",
  invoice_lines: "Invoice lines",
  returns: "Lead returns",
  replacements: "Lead replacements",
  quality_alerts: "Quality alerts",
  buyer_onboardings: "Buyer onboarding forms",
  test_inbox_messages: "Test inbox messages",
  files: "Lead, invoice and report files",
  testimonials: "Buyer testimonials",
  login_attempts: "Login attempt history",
};

export const collectionLabel = (k) => LABELS[k] || k.replace(/^_+/, "").replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase());

export const REASONS = {
  owner: "Owner login",
  staff: "Staff",
  test: "Test account",
  company: "Your company",
  page: "Buyer of a page you kept",
};

export const PAGE_KINDS = {
  company: "Company page",
  test: "Test account page",
  buyer: "Buyer page",
  house_test: "Test page",
  sample: "Sample page",
};

export const roleLabel = (r) => (r || "").replace(/_/g, " ");
